// extracted by mini-css-extract-plugin
module.exports = {"PageBody":"PageBody_PageBody__mQ7VN","narrow":"PageBody_narrow__1gQiS"};